import {
  Button,
  DateInput,
  TextInput,
  required,
  useDataProvider,
  useListContext,
  useNotify,
  useRefresh,
  useUnselectAll,
} from "react-admin";
import DoneIcon from "@mui/icons-material/Done";
import ThumbUpIcon from "@mui/icons-material/ThumbUpOffAlt";
import FormModal from "server/components/Modals/FormModal";
import { ACADEMIC_DECISIONS, DecisionTypes, StudentServicePath } from "utils/constants";

const AdvanceButton = () => {
  const { selectedIds, resource } = useListContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll(resource);

  // No try/catch: FormModal notifies on error and stays open.
  const advanceStudies = async data => {
    await dataProvider.create(`${StudentServicePath}${ACADEMIC_DECISIONS}`, {
      data: { decisionType: DecisionTypes.Advancement, educationDecisionIds: selectedIds, ...data },
    });
    notify("Успешно продължено обучение на избраните студенти", { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <FormModal
      triggerButton={
        <Button label="Продължи обучение">
          <ThumbUpIcon />
        </Button>
      }
      titleContent="Продължаване на обучение"
      onConfirm={advanceStudies}
      saveTitle="Продължи"
      saveIcon={<DoneIcon />}
      closeTitle="Затвори"
      dialogSize="xs"
    >
      <DateInput
        source="orderDate"
        label="Дата на заповед"
        validate={required()}
        helperText={false}
        fullWidth
      />
      <TextInput
        source="orderNumber"
        label="Номер на заповед"
        validate={required()}
        helperText={false}
        fullWidth
      />
      <TextInput
        source="note"
        label="Бележка"
        multiline
        fullWidth
      />
    </FormModal>
  );
};

export default AdvanceButton;
